import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { DOC_LABEL, formatCents, type PublicDocument } from "@handvero/shared";
import { api, errorText } from "../api";
import "./unterlagen.css";

/* Seite für Kunden: Über den Link aus der Mail oder von WhatsApp sehen und laden sie den Beleg herunter, ohne Konto. */

const day = (iso: string) => new Date(iso).toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });

export function BelegLink() {
  const { token = "" } = useParams();
  const [doc, setDoc] = useState<PublicDocument | null>(null);
  const [error, setError] = useState("");
  const base = `/api/public/documents/${encodeURIComponent(token)}`;

  useEffect(() => {
    document.title = "Ihr Beleg";
    const robots = document.createElement("meta");
    robots.name = "robots";
    robots.content = "noindex, nofollow";
    document.head.appendChild(robots);
    api
      .get<PublicDocument>(base)
      .then((d) => {
        setDoc(d);
        document.title = `${d.company}: ${DOC_LABEL[d.type]} ${d.number}`;
      })
      .catch((err) => setError(errorText(err)));
    return () => robots.remove();
  }, [base]);

  return (
    <div className="ul-page">
      <main className="ul-card">
        {error ? (
          <>
            <h1>Link nicht verfügbar</h1>
            <p className="ul-error" role="alert">
              {error}
            </p>
          </>
        ) : !doc ? (
          <div className="ul-loading" role="status" aria-label="Wird geladen" />
        ) : (
          <>
            <header className="ul-head">
              {doc.hasLogo && <img src={`${base}/logo`} alt={doc.company} className="ul-logo" />}
              <div>
                <b>{doc.company}</b>
                {doc.line && <small>{doc.line}</small>}
              </div>
            </header>
            <h1>
              {DOC_LABEL[doc.type]} {doc.number}
            </h1>
            {doc.message && (
              <blockquote className="ul-msg">
                <p>{doc.message}</p>
                {doc.sender && <cite>{doc.sender}</cite>}
              </blockquote>
            )}
            <ul className="ul-list">
              <li>
                <span className="ul-ico" aria-hidden="true">
                  PDF
                </span>
                <span className="ul-text">
                  <b>
                    {DOC_LABEL[doc.type]} {doc.number}
                  </b>
                  <small>
                    {formatCents(doc.grossCents)} · vom {day(doc.issueDate)}
                    {doc.dueDate && doc.type === "invoice" ? ` · zahlbar bis ${day(doc.dueDate)}` : ""}
                  </small>
                </span>
                <span className="ul-btns">
                  <a className="ul-btn ghost" href={`${base}/pdf?ansehen=1`} target="_blank" rel="noreferrer">
                    Ansehen
                  </a>
                  <a className="ul-btn" href={`${base}/pdf`} download>
                    Herunterladen
                  </a>
                </span>
              </li>
            </ul>
            <p className="ul-note">
              Dieser Link ist bis zum {day(doc.expiresAt)} gültig. Speichern Sie das PDF, wenn Sie es länger brauchen. Fragen beantwortet Ihnen {doc.company} direkt.
            </p>
          </>
        )}
      </main>
      <footer className="ul-foot">
        Bereitgestellt mit{" "}
        <a href="/" className="ul-brand">
          <span>Hand</span>Vero
        </a>{" "}
        · <a href="/rechtliches">Impressum und Datenschutz</a>
      </footer>
    </div>
  );
}
